import { FieldEntityType } from '@app/models/FieldEntityType';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';
import * as fromFields from './reducer';
import { ProjectTypeStoreState } from '@app/root-store/project-type-store';

export const getProjectTypesState = createFeatureSelector<ProjectTypeStoreState.State>('projectType');
export const getFieldState = createFeatureSelector<State>('field');

export const getSerachText = createSelector(getFieldState,
  (state: State) => state.searchText);

export const getFieldsArray = createSelector(getFieldState,
  (state: State) => fromFields.selectAll(state));

export const getFields = createSelector(getFieldState,
  (state: State) => fromFields.selectEntities(state));

export const getItemFields = createSelector(getFieldsArray,
  (fields) => fields && fields.filter(e => e.entityType === FieldEntityType.ITEM));

export const getProjectFields = createSelector(getFieldsArray,
  (fields) => fields && fields.filter(e => e.entityType === FieldEntityType.PROJECT));


export const getItemFieldsArray = createSelector(
  getProjectTypesState,
  getFieldsArray,
  getSerachText,
  (types, fieldsArray, searchText) => {
    if (fieldsArray && types) {
      return types.selectedType.sections.filter(e => e.entityType === FieldEntityType.ITEM).map(section => {
        return {
          ...section, fields: section.fields
            .map(field => fieldsArray.find(e => e._id === field
              && e.entityType === FieldEntityType.ITEM
              && e.label.toLowerCase().includes(searchText.toLowerCase())))
            .filter(x => x)
        };
      });
    } else {
      return [];
    }
  }
);
export const getProjectFieldsArray = createSelector(
  getProjectTypesState,
  getFieldsArray,
  getSerachText,
  (types, fieldsArray, searchText) => {
    if (fieldsArray && types) {
      return types.selectedType.sections.filter(e => e.entityType === FieldEntityType.PROJECT).map(section => {
        return {
          ...section, fields: section.fields
            .map(field => fieldsArray.find(e => e._id === field
              && e.entityType === FieldEntityType.PROJECT
              && e.label.toLowerCase().includes(searchText.toLowerCase())))
            .filter(x => x)
        };
      });
    } else {
      return [];
    }
  }
);

export const getLibraryFieldsArray = createSelector(getFieldState,
  (state: State) => state.libraryFields);

export const getFieldsOptions = createSelector(getItemFields,
  (fieldsArray) => fieldsArray.map(field => ({ id: field.techName, name: field.label, type: field.type })));
